/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-12-13 09:24:47
 */
/*
 * 员工相关接口
 */
import request from '../request'
import { ILoginParams, IUpdatePwdParams } from '../model'

enum Api {
  LOGIN_API = '/staff/webLogin',
  LOGOUT_API = '/staff/webLoginOut',
  FORGET_PWD = '/staff/forgetPwd',
  CHANGE_INIT_PWD = '/staff/changeInitPwd',
  CHANGE_PWD = '/staff/changePwd'
}

export default class ajaxAuthService {
  /**
   * 登录
   * @param data
   * @returns
   */
  static login(data: ILoginParams): Promise<any> {
    return request.post(Api.LOGIN_API, data)
  }
  /**
   * 退出登录
   * @returns
   */
  static logOut(): Promise<any> {
    return request.get(Api.LOGOUT_API)
  }
  /**
   * 忘记密码
   * @param data
   * @returns
   */
  static forgetPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.FORGET_PWD, data)
  }
  /**
   * 修改初始密码
   * @param data
   * @returns
   */
  static changeInitPwd(data: ILoginParams): Promise<any> {
    return request.post(Api.CHANGE_INIT_PWD, data)
  }
  /**
   * 修改密码
   * @param data
   * @returns
   */
  static changePwd(data: IUpdatePwdParams): Promise<any> {
    return request.post(Api.CHANGE_PWD, data)
  }
}
